module.exports = __webpack_public_path__ + "static/media/zeelandia-doc.0a8618af.svg";